import { create } from 'zustand';

const useModalImageStore = create((set) => ({
  imgSrc: null,
  setImgSrc: (imgSrc) => set({ imgSrc }),

  imgSize: undefined, // undefined | 'sm' | 'md' | 'lg'
  setImgSize: (imgSize) => set({ imgSize }),

  isOpenModalImage: null,
  setIsOpenModalImage: (isOpenModalImage) => set({ isOpenModalImage }),

  onViewImage: (payload) => {
    const { imgSrc, imgSize } = payload;
    set(() => {
      return {
        imgSrc,
        imgSize,
        isOpenModalImage: true,
      };
    });
  },
}));

export default useModalImageStore;
